'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = CheckboxGroup;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./checkbox-group.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Checkbox Group Component.
 * @param {Object} props The new component properties.
 * @returns {ReactElement} HTML markup for the component
 */
function CheckboxGroup(props) {
    var _props$type = props.type,
        type = _props$type === undefined ? '' : _props$type,
        children = props.children;


    return (0, _jsx3.default)('div', {
        className: 'sb-checkbox-group--' + type
    }, void 0, children);
}
//# sourceMappingURL=CheckboxGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/checkboxGroup/CheckboxGroup.js
// module id = 555
// module chunks = 0